import { action } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Controller from '@ember/controller';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import cloneDeep from 'lodash.clonedeep';

export default class MapController extends Controller {
  @service router;

  @readOnly('model') import;

  updateValidateRules = task({ drop: true }, async () => {
    let validateRules = cloneDeep(this.import.validateRules);

    await this.import.resetStateToPreprocessing.perform();

    let preprocessedAttributes = this.import.preprocessMeta.attributes;

    await this.import.updateValidateRules.perform({
      ...validateRules,
      onlyExisting: true,
      skipAttributes: preprocessedAttributes.map(() => false),
      mapAttributes: preprocessedAttributes.map(() => null),
    });
  });

  validate = task({ drop: true }, async () => {
    await this.updateValidateRules.perform();
    await this.import.validate.perform();

    this.router.transitionTo('segments.segment.imports.csv.setup.validating', this.import.segment, this.import);
  });

  @action
  cancelImport() {
    let segmentId = this.import.belongsTo('segment').id();

    this.import.destroyRecord().then(() => {
      this.router.transitionTo('segments.segment', segmentId);
    });
  }
}
